import { Chip, styled } from '@mui/material';

export const StyledChip = styled(Chip)(() => ({
  maxWidth: 'min-content',
}));

StyledChip.defaultProps = {
  variant: 'outlined',
  color: 'secondary',
};
